/**
 * What a finished clone says: its name, the references it could not keep, and whether
 * the workshop's own RAG data is being rebuilt.
 */
import React from 'react';
import { Button, Actions, StatusLine, FieldHelp } from '../InstanceSettings/formPrimitives';
import { useTranslation } from '../../hooks/useTranslation.jsx';

export default function CloneResult({ result, onOpen }) {
  const { t } = useTranslation();
  return (
    <div style={{ marginTop: 12 }}>
      <Actions>
        <StatusLine>{t('clone.cloned', { name: result.name })}</StatusLine>
        {onOpen && <Button type="button" $variant="primary" onClick={() => onOpen(result)}>{t('clone.openClone')}</Button>}
      </Actions>
      {result.warnings?.length > 0 && (
        <>
          <FieldHelp>{t('clone.warningsTitle')}</FieldHelp>
          <ul style={{ margin: '4px 0 0', paddingLeft: 18, fontSize: 13, opacity: 0.8 }}>
            {result.warnings.map((w) => (
              <li key={`${w.table}.${w.column}.${w.action}`}>
                {t(w.action === 'dropped' ? 'clone.warningDropped' : 'clone.warningCleared', w)}
              </li>
            ))}
          </ul>
        </>
      )}
      {result.reindex && (
        <FieldHelp>
          {result.reindex.started ? t('clone.reindexStarted') : t('clone.reindexFailed', { error: result.reindex.error })}
        </FieldHelp>
      )}
    </div>
  );
}
